module.exports = __webpack_public_path__ + "static/media/pefin-homepage.17aecc77.png";